import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import useDate from '../components/useDate';
import { useDispatch, useSelector } from 'react-redux';
import { logInUserAsync, fetchUserAsync } from '../store/userSlice';

import './Login.css';
import { DataContainer } from '../components/DataContainer';
import { unwrapResult } from '@reduxjs/toolkit';

function Login({  }) {
    const navigate = useNavigate();

    const [ username, setUsername ] = useState(null);
    const [ password, setPassword ] = useState(null);

    const dispatch = useDispatch();
    const currentDate = useDate();

    const hours = ('0'+currentDate.date.getHours()).slice(-2);
    const minutes = ('0'+currentDate.date.getMinutes()).slice(-2);
    const dayOfMonth = ('0'+currentDate.date.getDate()).slice(-2);
    const weekday = [ "Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev" ][currentDate.date.getDay()];

    async function onLogIn() {
        await unwrapResult(await dispatch(logInUserAsync({ username, password })));
        await unwrapResult(await dispatch(fetchUserAsync()));
        
        navigate("/platform");
    }



    return (
        <div className='column center-main center-cross' id="back">

            <DataContainer actionType={'user/logInUser'} >
                <div className="panel" style={{ minWidth: 360 }}>

                    <div className="column p16 g16">

                        <p style={{ fontSize: '24px' }}>Sisselogimine</p>

                        <div className="column g16 p16">
                            <div className="column g8">
                                <p class="input-label">Kasutajatunnus</p>
                                <input type="text" name="" id="" onChange={(e) => setUsername(e.target.value)} />
                            </div>

                            <div className="column g8">
                                <p class="input-label">Parool</p>
                                <input type="password" name="" id="" onChange={(e) => setPassword(e.target.value)} />
                            </div>
                        </div>

                    </div>

                    <div className="row end p16" style={{ backgroundColor: '#c7795a' }}>
                        <button onClick={onLogIn} className='glass'>Sisene</button>
                    </div>
                </div>
            </DataContainer>

            <div className='column' id="time">
                <p className='greeting'>{currentDate.wish}</p>
                <p className='time' style={{ fontWeight: 700, marginBlock: -16 }}>{hours}:{minutes}</p>
                <div className="row end">
                    <p className='one-liner'>{weekday} {dayOfMonth}</p>
                </div>
            </div>
        </div>
    );
}

export default Login;